import Header from './components/Header';
import Hero from './components/Hero';
import AboutSection from './components/AboutSection';
import CommentsSection from './components/CommentsSection';
import MediaSection from './components/MediaSection';
import IndexSection from './components/IndexSection';
import FAQSection from './components/FAQSection';
import UpdatesSection from './components/UpdatesSection';
import TopicsSection from './components/TopicsSection';
import ContactSection from './components/ContactSection';
import FeaturesSection from './components/FeaturesSection';
import AppSection from './components/AppSection';
import RankingSection from './components/RankingSection';
import CardsSection from './components/CardsSection';
import CarouselSection from './components/CarouselSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <AboutSection />
        <CommentsSection />
        <MediaSection />
        <IndexSection />
        <FAQSection />
        <UpdatesSection />
        <TopicsSection />
        <ContactSection />
        <FeaturesSection />
        <AppSection />
        <RankingSection />
        <CardsSection />
        <CarouselSection />
      </main>
      <Footer />
    </>
  );
}